import { PureComponent } from "react"
import PropTypes from "prop-types"

import "./tag.scss"

class Tag extends PureComponent {
  removeTag = () => {
    this.props.removeTag?.(this.props.label)
  }

  render() {
    const { label, hasRemoveFunction, hasHashTag, className, title } = this.props

    return (
      <div className="tag">
        <div className={`tag__inner ${className || ""}`}>
          {hasHashTag ? `# ${label}` :
            <>
              <button
              className="trancate"
                title={title || ""}
              >{label}</button>
            </>
          }
          {hasRemoveFunction && (
            <button
              type="button"
              className="tag__remove"
              title={title || ""}
              onClick={this.removeTag}
            >
              remove
            </button>
          )}
        </div>
      </div>
    )
  }
}

Tag.propTypes = {
  label: PropTypes.string.isRequired,
  hasRemoveFunction: PropTypes.bool,
  hasHashTag: PropTypes.bool,
  removeTag: PropTypes.func,
  className: PropTypes.string,
}

export default Tag
